// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__+uqJJ","section-1":"styles_section-1__Q7N2q","content":"styles_content__cbjvg","section-2":"styles_section-2__Oprj3"};